import GlobalNavigation from './GlobalNavigation'

export default GlobalNavigation